export const cleanObject = (obj) => {
  return Object.fromEntries(
    Object.entries(obj).filter(([_, value]) => {
      if (Array.isArray(value)) return value.length > 0;

      if (typeof value === "object" && value !== null) {
        return Object.keys(value).length > 0;
      }

      if (value === null || value === undefined || value === "") {
        return false;
      }

      return true;
    }),
  );
};
